
<div class="custom-background justify-content-center">
    <div class="text-center">
        <h1 class="title mb-0">ERRO 404</h1>
        <h2 class="subtitle">Página não encontrada!</h2>
    </div>
</div>
